@if (externalUrl()) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayPositionStrategy]="globalOverlay"
    [cdkConnectedOverlayOpen]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-dark-backdrop"
    (backdropClick)="hide()"
    cdkConnectedOverlayPanelClass="external-url-panel"
  >
    <main class="external-url-qr-content">
      <div class="modal-header">
        <h2 class="title">
          @if (externalUrlTitleName()) {
            {{ translation.webapps.reserve | transloco }} {{ externalUrlTitleName() }}
          } @else {
            {{ translation.navigation.scanQrCode | transloco }}
          }
        </h2>

        <button type="button" class="close-btn" (click)="hide()">
          <cue-icon [icon]="ICONS.cueClose"></cue-icon>
        </button>
      </div>

      <div class="modal-body">
        @if (!externalUrlTitleName()) {
          <p class="title-qr">{{ translation.navigation.scanAndOpenUrlInMobile | transloco }}</p>
        }
        <p class="title-qr">
          @if (descriptionText()) {
            {{ descriptionText() | transloco }}
          } @else {
            <u>{{ externalUrl() }}</u>
          }
        </p>

        <div class="inner-content-qr">
          <assist-qr-code-viewer [currentUriData]="externalUrl()" [hideText]="true" />
        </div>
      </div>
    </main>
  </ng-template>
}
